import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

/* Result */
import Result from 'iotera-base/result';

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks';
import { actions as notificationActions } from '../../redux/ducks/notification';
import { actions as modalActions } from '../../redux/ducks/modal';
import { actions as loadingActions } from '../../redux/ducks/loading';

/* Routes */
import { domainIsTenant as dit, AppLink, S } from '../../routes/routes';

/* Object Json */
import { safeGetWithType, safeGet } from 'iotera-base/json';

import './style.scss';

import { SizeMe } from 'react-sizeme';
import { copyTextToClipboard } from '../../lib/components/function';
import IoteraClass from '../../lib/components/react/react-class';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../lib/components/callbackGlobal';

const WKEY = 'CREDENTIALS';
const DELETE = 'DELETE';
const REGENERATE = 'REGENERATE';
const RELOAD = 'RELOAD';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const OPEN_V0 = 19;

class CredentialsCard extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      dropdownOpen: {},
    };
    this.onDelete = this.onDelete.bind(this);
    // this.onOpen = this.onOpen.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  toggle = (e, str) => {
    const _this = this;
    setTimeout(
      () =>
        _this.setState({
          modal: true,
        }),
      0,
    );
    setTimeout(() => _this.dismissLoading(), 1500);
  };

  dismissLoading() {
    setTimeout(() => this.setState({ modal: false }), 1500);
  }

  onDelete = id => () => {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus credentials ini?',
      null,
      () =>
        this.props.wSingleRequestCall({
          id: DELETE,
          body: {
            id,
          },
        }),
      null,
      null,
    );
  };

  onRegenerate = id => () => {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin me-regenerate secret? Seluruh akses yang memakai secret sebelumnya akan di-non-aktifkan.',
      null,
      () =>
        this.props.wSingleRequestCall({
          id: REGENERATE,
          body: {
            id,
          },
        }),
      null,
      null,
    );
  };

  onOpen = path => {
    const _this = this;
    const _props = _this.props;
    _this.forceUpdate();
    _props.history.push('.' + S + path);
  };

  onMouseEnter(key, cat) {
    const _this = this;
    const _state = _this.state;
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    dropdownOpen[key] = true;
    _this.setState({ dropdownOpen });
  }

  onMouseLeave(key) {
    const _this = this;
    const _state = _this.state;
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen });
  }

  gotoUpdate = id => () => {
    this.props.history.push(`./@credentials/update/${id}`);
  };

  render() {
    const self = this;
    let data = safeGetWithType(self.props, ['data'], []);
    let showSkeleton = safeGetWithType(self.props['show'], false);
    let credentialsCards = [];
    for (let i in data) {
      const credentialsItem = data[i];
      const id = safeGetWithType(credentialsItem, 'id', '');
      const category = safeGetWithType(credentialsItem, 'category', OPEN_V0);
      const categoryText = safeGetWithType(
        credentialsItem,
        'category_text',
        '',
      );
      const credsId = safeGetWithType(credentialsItem, 'credentials_id', '');
      const credsSecret = safeGetWithType(
        credentialsItem,
        'credentials_secret',
        '',
      );

      let dropdownIsOpen = safeGetWithType(
        self.state,
        ['dropdownOpen', id],
        false,
      );
      credentialsCards.push(
        <div key={id} className="io-card card__shadow-sm io-card__direct mb-4">
          {/* onClick={self.gotoUpdate(id)}> */}
          <div className="io-card-body card-body__compact">
            <div className="io-row align-items-center">
              <div className="io-col">
                <p>{categoryText}</p>
                <h5>{credsId}</h5>
                <h5>{credsSecret}</h5>
              </div>
              <div
                className="io-col-auto"
                onMouseLeave={e => self.onMouseLeave(id)}
              >
                <UncontrolledDropdown isOpen={dropdownIsOpen}>
                  <DropdownToggle
                    style={{ padding: 0, backgroundColor: 'transparent' }}
                  >
                    <div
                      tag="div"
                      className="io-btn btn-sm btn-control"
                      role="button"
                      data-toggle="popover"
                      onMouseOver={e => self.onMouseEnter(id)}
                      style={{ cursor: 'pointer', padding: 4 }}
                    >
                      <span className="material-icons">more_horiz</span>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu style={{ padding: 0, margin: 0 }}>
                    <DropdownItem
                      style={{ margin: 0 }}
                      onClick={() => {
                        copyTextToClipboard(credsId);
                        self.props.showSingleNotification({
                          message: 'Credentials Id copied to clipboard.',
                        });
                      }}
                    >
                      Copy Id
                    </DropdownItem>
                    <DropdownItem
                      style={{ margin: 0 }}
                      onClick={() => {
                        copyTextToClipboard(credsSecret);
                        self.props.showSingleNotification({
                          message: 'Credentials Secret copied to clipboard.',
                        });
                      }}
                    >
                      Copy Secret
                    </DropdownItem>
                    <DropdownItem
                      style={{ margin: 0 }}
                      onClick={self.onRegenerate(id)}
                    >
                      Regenerate Secret
                    </DropdownItem>
                    <DropdownItem
                      style={{ margin: 0 }}
                      onClick={self.gotoUpdate(id)}
                    >
                      Edit
                    </DropdownItem>
                    <DropdownItem
                      style={{ margin: 0 }}
                      onClick={self.onDelete(id)}
                    >
                      Hapus
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </div>
          </div>
        </div>,
      );
    }

    return (
      <div className="io-container mt-12">
        <div className="io-row align-items-center mb-4">
          <div className="io-col">
            <h3 className="mt-4 font-weight-normal">List of Credentials</h3>
            <h6 className="text-gray-300 font-weight-normal">
              Manage credentials
            </h6>
          </div>
          <div className="io-col-auto">
            <AppLink {...self.props} to={'@credentials/create'}>
              <div className="io-btn io-btn-primary">Create Credentials</div>
            </AppLink>
          </div>
        </div>
        {showSkeleton ? (
          <div>
            <Skeleton variant="rect" width={'100%'} height={67} />
          </div>
        ) : (
          credentialsCards
        )}
      </div>
    );
  }
}

class Credentials extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      credentials: {},
    };
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props);
    _props.wInitRequestCall({
      wparam: { ...domainIsTenant, path: '/service/web/credentials/list' },
      wcallback: {
        started: function (id) {
          // TODO Loading
          _props.showLoading();
          _this.setState({
            loading: true,
          });
        },
        finished: function (id, result) {
          // TODO Loading
          _props.hideLoading();
          let credentials = safeGetWithType(
            result,
            ['body', 'credentials'],
            [],
          );
          _this.setState({
            loading: false,
            credentials,
          });
        },
      },
    });

    _props.wSetConfig({
      single_config: {
        [DELETE]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/credentials/delete',
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true,
              });
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR,
                );
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false,
                  });
                  _props.showSingleNotification({
                    message: 'Hapus Credentials Sukses',
                    level: 'success',
                  });
                  _props.wSingleRequestCall({
                    id: RELOAD,
                  });
                  return;
                }
              }
              _props.showSingleNotification({
                message: 'Hapus Credentials Gagal',
                position: 'tr',
                level: 'error',
              });
            },
          },
        },
        [REGENERATE]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/credentials/regenerate/secret',
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true,
              });
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR,
                );
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false,
                  });
                  _props.showSingleNotification({
                    message: 'Generate Credentials Sukses',
                    level: 'success',
                  });
                  _props.wSingleRequestCall({
                    id: RELOAD,
                  });
                  return;
                }
              }
              _props.showSingleNotification({
                message: 'Generate Credentials Gagal',
                position: 'tr',
                level: 'error',
              });
            },
          },
        },
        [RELOAD]: {
          wparam: { ...domainIsTenant, path: '/service/web/credentials/list' },
          wcallback: {
            started: function (id) {
              // TODO Loading
              _this.setState({
                loading: true,
              });
            },
            finished: function (id, result) {
              // TODO Loadingif (result.code === Result.HTTP.OK) {
              const items = safeGet(_props, ['items']);
              const responseResult = safeGetWithType(
                result,
                ['body', 'response_result'],
                Result.UNKNOWN_ERROR,
              );
              if (responseResult === Result.SUCCESS) {
                _this.setState({
                  loading: false,
                  credentials: safeGetWithType(
                    result,
                    ['body', 'credentials'],
                    items,
                  ),
                });
                return;
              }
            },
          },
        },
      },
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props);
  }

  render() {
    const self = this;
    const { loading, credentials } = self.state;
    return (
      <div>
        <SizeMe>
          {({ size }) => (
            <CredentialsCard
              {...self.props}
              data={credentials}
              displaySize={size}
              show={loading}
            />
          )}
        </SizeMe>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state, 'credentials'),
  };
};

const mapDispatchToProps = dispatch => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch),
  ...bindActionCreators(modalActions, dispatch),
  ...bindActionCreators(loadingActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Credentials);
